const OrderFiltersSkeleton = () => (
  <div className="order-filters-container skeleton-container">
    <div className="filters-header">
      <div className="filters-title">
        <div className="skeleton-icon-sm" />
        <div style={{ width: '60px', height: '16px' }} />
        <div style={{ width: '80px', height: '20px', borderRadius: '20px', ml: '8px' }} />
      </div>
      <div style={{ width: '100px', height: '32px', borderRadius: '20px' }} />
    </div>
    
    <div className="filters-row">
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} className="filter-group">
          <div style={{ width: '80px', height: '12px' }} />
          <div style={{ width: '100%', height: '40px', borderRadius: '8px' }} />
        </div>
      ))}
    </div>
    
    <div className="active-filters">
      {Array.from({ length: 2 }).map((_, i) => (
        <div key={i} style={{ width: '120px', height: '28px', borderRadius: '20px' }} />
      ))}
    </div>
  </div>
);

export default OrderFiltersSkeleton;